export default __webpack_public_path__ + "static/media/closed-eye.8042f802.svg";